<template>
  <div class="menu-bar">
    <div class="menBar_p">
      <div class="menBar">
        <div class="menuBarleft">
          <p v-show="$route.query.year">
            <span @click="needshowSetting(7)" v-show="menuIssue.index!=0">上一期</span>
            <span @click="needshowSetting(8)" v-show="menuIssue.leng-1 != menuIssue.index">下一期</span>
          </p>
          <!-- @click="showSetting(3)" -->
          <div class="iconWr switchReadBookList" style="marginLeft:13px">
              <div class="switchReadBook_item">
                <ul hidden>
                  <li v-for="(item,index) in switchReadBook" :key="index" @click="switchReadBookFn(index)">{{item.title}}</li>
                </ul>
                <div class="switchReadBook_text">{{switchReadBook[switchReadBook_index].title}}</div>
              </div>
          </div>
          <div class="jinDTiao">
            <!-- <el-tooltip effect="dark" content="目录" placement="top" transition="el-zoom-in-bottom">
              <div class="iconWr" @click="showSetting(3)">
                <img src="@/assets/epub/menu.png" alt />
              </div>
            </el-tooltip> --> 
          </div>
        </div>
        <div class="menuBarCenter">
          <div class="pr_next">
            <el-tooltip effect="dark" content="上一页" placement="top" transition="el-zoom-in-bottom">
              <div class="iconWr" @click="setPagesize(1)" style="border:none">
                <img src="@/assets/epub/next.png" alt style="width:32px;height:32px" />
              </div>
            </el-tooltip>
              <div class="iconWr iconWrInput" style="border:none">
                <input type="number" v-model="inputval" v-show="setinputState" @keyup.enter="oniconWrInputSubmit" @blur="setinputState=false">
                <div class="iconWrInput_text" @click="setinputState=!setinputState" v-show="!setinputState">{{footerinput}}</div>
              </div>
            <el-tooltip effect="dark" content="下一页" placement="top" transition="el-zoom-in-bottom">
              <div class="iconWr" @click="setPagesize(2)" style="border:none">
                <img src="@/assets/epub/per.png" alt style="width:32px;height:32px" />
              </div>
            </el-tooltip>
          </div>
        </div>
        <div class="menuBarright">
          <div class="iconWr iconWrTransition" style="width:auto;"  ref="progressboxWarp">
            <transition name="el-zoom-in-center">
              <div class="progress" v-show="stateProgress">
                <el-slider v-model="stateProgress_val" style="width:150px" :show-tooltip="false" @change="stateProgress_change" @input="stateProgress_change"></el-slider>
              </div>
             </transition>
            <el-tooltip effect="dark" content="缩放" placement="top" transition="el-zoom-in-bottom">
              <div class="iconWr" style="border:none" @click="stateProgress=!stateProgress">
                <img src="@/assets/epub/jindu.png" alt />
              </div>
            </el-tooltip>
          </div>
          <el-tooltip effect="dark" content="设置背景" placement="top" transition="el-zoom-in-bottom">
            <div class="iconWr" style="margin:0 12px" @click="setBackgroundFrame_fn(true)">
              <img src="@/assets/epub/pageSet.png" alt />
            </div>
          </el-tooltip>
          <!-- <el-tooltip effect="dark" content="返回" placement="top" transition="el-zoom-in-bottom">
            <div class="iconWr" style="margin:0px">
              <img src="@/assets/epub/houtui.png" alt />
            </div>
          </el-tooltip> -->
          <!-- <el-tooltip effect="dark" content="返回" placement="top" transition="el-zoom-in-bottom">
            <div class="iconWr" @click="goBack">
              <img src="@/assets/epub/houtui.png" alt />
            </div>
          </el-tooltip>  -->
        </div>
      </div>
    </div>
    <transition name="el-zoom-in-top">
      <div class="centerBox_pos" v-show="setBackground_frame">
        <div class="centerBoxPosSub">
          <div class="clons" @click="setBackgroundFrame_fn(false)"><img src="@/assets/epub/guabbi.png" alt=""></div>
          <h6>阅读背景</h6>
          <ul>
            <li v-for="(item,index) in themeList" :key="index" @click="setTheme(index)"><p  :style="{background: item.style.body.background,border:index ==needsetThemeIndex ? '4px solid #FF5858' :'none'}"></p><span>{{item.name}}</span></li>
          </ul>
        </div>
      </div>
    </transition>


    <!-- //目录 -->
    <transition name="el-zoom-in-top">
      <div class="content-mask" v-show="ifShowContent" @click="hideContent">
        <content-view
          :ifShowContent="ifShowContent"
          :v-show="ifShowContent"
          :navigation="navigation"
          :bookAvailable="bookAvailable"
          @jumpTo="jumpTo"
        ></content-view>
      </div>
    </transition>
    <!-- //缩略图 -->
    <transition name="el-zoom-in-top">
      <div class="content_suolue" v-show="switchReadBook_index==1"> 
        <div class="carouselWarp">
          <div class="posiBtn position_LeftBtn" @click="nextSwiperindex(1)">
            <img src="@/assets/epub/quanjuleft.png" alt />
          </div>
          <div class="posiBtn position_RightBtn" @click="nextSwiperindex(2)">
            <img src="@/assets/epub/quanjuright.png" alt />
          </div>
          <el-carousel height="200px" ref="carousel_menuBer" arrow="always" :autoplay="false" indicator-position="outside"> 
            <el-carousel-item v-for="(item,index) in getDataThumbnaiLists" :key="index">
              <ul>
                <li v-for="(itemneed,needIndex) in item" :key="needIndex" @click="goPageimg(index*6+needIndex+1)">
                  <!-- <span style="color:#ffffff">{{(index*6+needIndex+1)}}</span> -->
                  <img :src="itemneed" alt="">
                </li>
              </ul>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ContentView from "./ContentView.vue";
export default {
  name: "",
  props: {
    ifTitleAndMenuShow: {
      type: Boolean,
      default: false
    },
    fontSizeList: Array,
    defaultFontSize: Number,
    themeList: Array,
    defaultTheme: Number,
    bookAvailable: Boolean,
    navigation: Object,
    progressval:Number,
    footerinput:String,
    menuIssue:Object,
    getDataThumbnaiLists:Array
  },
  data() {
    return {
      stateProgress_val:0,
      swiperIndex:0,
      setBackground_frame:false,
      stateProgress:false,
      ifSettingShow: false,
      showTag: 0,
      progress: 0,
      ifShowContent: false,
      needsetThemeIndex:0,
      switchReadBook:[{title:'双页'},{title:"缩略图"}],
      switchReadBook_index:0,
      routerSwiper_text:"2-3页 共70页",
      setinputState:false,
      inputval:''
    };
  },

  components: {
    ContentView
  },

  computed: {},

  beforeMount() {},

  mounted() {

    document.addEventListener('click',(e)=>{
//         if(!this.$refs.progressboxWarp.contains(e.target)){
//             this.stateProgress = false;
//         }
    })
  },

  methods: {
    goPageimg(index){
      this.switchReadBook_index=0; 
      this.$emit("goPageimg",index)
    },
    oniconWrInputSubmit(e){ 
      this.setinputState=false
      if(this.inputval!='' &&this.inputval!=null){
        this.$emit("oniconWrInputSubmit",this.inputval)
      }
      this.inputval=''
    },
    nextSwiperindex(num){
      if(num==1){
        if(this.swiperIndex==0){
          return false
        }else{
          this.swiperIndex=this.swiperIndex-1
        }
      }else{
        if(this.swiperIndex==Number(this.$route.query.pagecount)){
          return false
        }else{
          this.swiperIndex=this.swiperIndex+1
        }
      }
      this.$refs.carousel_menuBer.setActiveItem(this.swiperIndex);
    },
    switchReadBookFn(index){
      this.switchReadBook_index=index
    },
    setBackgroundFrame_fn(state){
      this.setBackground_frame=state
    },
    setPagesize(index) {
      this.$emit("setPagesize", index);
    },
    showSetting(index) {
      this.showTag = index;
      if (this.showTag === 3) {
        this.ifSettingShow = false;
        this.ifShowContent = true;
      }
    },
    needshowSetting(index){
        this.$emit("setMenuSub",index)
    },
    hideSetting() {
      this.ifSettingShow = false;
    },
    setFontSize(fontSize) {
      this.$emit("setFontSize", fontSize);
    },
    setTheme(index) {
      this.needsetThemeIndex=index;
      this.$emit("setTheme", index);
    },
    //进度条发生改变的时候
    stateProgress_change(val){
      this.$emit(`onProgressChange`, val);
    },
    hideContent() {
      this.hideSetting();
      this.ifShowContent = false;
    },
    jumpTo(target) {
      this.$emit("jumpTo", target);
    },
    goBack(){
      this.$router.go(-1)
    }
  },

  watch: {
    progressval(){
      this.stateProgress_val=this.progressval
    }
  }
};
</script>
<style lang='less' scoped>

 .content_suolue{
    width: 100%;
    height: calc( 100% - 50px ) ;
    position: fixed;
   left: 0;
   top:0;
   background: #000000;
   z-index:99;
   .carouselWarp{ 
    width:1000px;
    margin: auto;
    margin-top: 10%;
    position: relative;
    // background: #ffffff;
    .posiBtn{
      color: #ffffff;
      width: 48px;
      height: 48px;
      text-align: center;
      line-height: 30px;
      font-size: 20px;
      position: absolute;
      // font-weight: 600;
      z-index: 999;
      top: 40%; 
      cursor: pointer; 
      transition: 0.2s;
      img {
        width: 48px;
      }
    }
    .position_LeftBtn{
      left: -80px;
    }
    .position_RightBtn{
      right: -80px;
    }
    ul{
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      li{
        height: 100%;
      display: flex;
      align-items: center;
      transition: 0.3s;
      cursor: pointer;
      img{
        height: 85%;
      }
      }
      li:hover{
        transform: scale(1.06);
      }
    }
  }
 }
.iconWrTransition{
  transition: 0.2s;
}
.centerBox_pos{
	width: 100%;
	height: 100%;
	position: fixed;
	z-index: 999;
	top: 0;
	left: 0;
	background: rgba(0,0,0,0.3);
}
.centerBoxPosSub{
	width: 470px!important;
	height: 296px;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%,-50%);
	background: #FFFFFF;
	border-radius:4px;
}

.centerBox_pos .clons{
	color: #FFFFFF;
	padding: 20px 20px 0 0 ;
	display: flex;
	justify-content: flex-end;
}
.centerBox_pos .clons img{
	width: 14px;
	cursor: pointer;
	height: 14px;
}
.centerBox_pos h6{
	text-align: center;
	font-size:28px;
	font-weight:500;
	color:rgba(66,71,108,1);
	line-height:28px;
	padding: 38px 0 40px 0;
}
.centerBox_pos  ul{
	display: flex;
	justify-content: space-between;
	padding: 0 50px;
}
.centerBox_pos  ul li{
	cursor: pointer;
}
.centerBox_pos  ul li p{
	width:60px;
	height:60px;
	border-radius: 50%;
	/* border: 4px solid #FF5858; */
  box-sizing: border-box;
      box-shadow: 0px 0px 5px rgba(0,0,0,0.2);
  transition: 0.2s;
}
.centerBox_pos  ul li span{
	height:14px;
	font-size:14px;
	display: block;
	font-weight:500;
	text-align: center;
	color:rgba(66,71,108,1);
	line-height:14px;
	padding-top: 10px;
}
.menu-bar {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 120;
  background: rgba(34, 34, 34, 1);
  -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -khtml-user-select: none;
    user-select: none;
  .menBar {
    width: 1200px;
    margin: auto;
    display: flex;
    height: 50px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #ffffff;
    .menuBarleft {
      width: 33%;
      display: flex;
      align-items: center;
      p {
        width: 130px;
        justify-content: space-between;
        display: flex;
        align-items: center;
        span {
          display: block;
          width: 56px;
          height: 36px;
          border-radius: 4px;
          border: 1px solid rgba(230, 230, 230, 1);
          text-align: center;
          line-height: 36px;
          transition: 0.2s;
          cursor: pointer;
        }
        span:hover {
          background: #333333;
        }
      }
      .jinDTiao {
        margin-left: 60px;
        justify-content: space-between;
        display: flex;
        align-items: center;
      } 
    }
    .menuBarCenter {
      width: 33%;
      display: flex;
      justify-content: center;
      .pr_next {
        display: flex;
        align-items: center;
      }
    }
    .menuBarright {
      width: 33%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .progress {
        overflow: hidden;
        padding: 0 10px 0 12px;
      }
    }
    .iconWr {
      width: 36px;
      height: 36px;
      border-radius: 4px;
      border: 1px solid rgba(230, 230, 230, 1);
      display: flex;
      justify-content: center;
      cursor: pointer;
      align-items: center;
      transition: 0.2s;
      img {
        width: 18px;
        height: 18px;
      }
    }
    .iconWr:hover {
      background: #333333;
    }
    .iconWrInput{
       width: 150px;
      input,.iconWrInput_text{
        width: 100%;
        outline: none; 
        background: none;
        color: #ffffff;height: 36px;
        border: 1px solid #ffffff;
        border-radius: 4px;
        height: 36px;
        line-height:36px;
        text-align: center;
      }
    }
    .switchReadBookList{
      width: 62px!important;
      text-align: center;
      .switchReadBook_item{
        position: relative;
        width: 100%;
        line-height: 36px;
        height: 100%;
        ul{
          position: absolute; 
          z-index:9999;
          width: 100%;
          background: #222222;
          bottom: 36px;
          border: 1px solid #ffffff;
          border-radius: 5px;
          margin-left: -1px;
          overflow: hidden;
          li{
            height: 36px;
            line-height: 36px;
          }
          li:hover{
            background: #333333;
          }
        }
        .switchReadBook_text{
          
        }
      }
      .switchReadBook_item:hover ul{
        display: block;
      }
    }
  }

  .content-mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 101;
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: flex-end;
    background: rgba(51, 51, 51, 0.8);
  }
}

</style>
<style >
  .menu-bar .el-slider__button {
    width: 10px!important;
    height: 10px!important;
    border-color:#FF5858;
}
.menu-bar .el-slider__bar{
    background-color:#FF5858;
}
</style>
